export const LANGS = {
	EN: 'en',
	ES: 'es',
};
